import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { getStatisticsEmails } from 'actions/statistics/emails';

import DatePicker from 'material-ui/DatePicker';
import Checkbox from 'material-ui/Checkbox';

/**
 * @param {{
 *  from: Date,
 *  until: Date,
 *  changeDateRange: (from: Date, until: Date) => void,
 *  getStatisticsEmails: (from: number, until: number) => void,
 *  handleNormalize: () => void,
 *  checked: boolean,
 *  handleWorkingHours: () => void,
 *  workingHours: boolean,
 * }} param0 
 * @returns 
 */
const RangeDates = ({
    from, 
    until,
    changeDateRange, 
    getStatisticsEmails, 
    handleNormalize, 
    checked, 
    handleWorkingHours,
    workingHours,
}) => {
    const [fromMinDate] = useState(moment([2017, 10, 3]).toDate());
    const [fromMaxDate, setFromMaxDate] = useState(until);
    const [untilMinDate, setUntilMinDate] = useState(from);
    const [untilMaxDate] = useState(moment().toDate());
    const [fromDate, setFromDate] = useState(from);
    const [untilDate, setUntilDate] = useState(until);

    useEffect(() => {
        setFromMaxDate(until);
        setUntilMinDate(from);
        setFromDate(from);
        setUntilDate(until);
    }, [from, until]);

    const changeFromDate = (e, date) => {
        setFromDate(date);
        setUntilMinDate(date);
        
        changeDateRange(date, untilDate);
        getStatisticsEmails(
            moment(date).utcOffset(0, true).valueOf(),
            moment(untilDate).utcOffset(0, true).valueOf(),
        );
    };

    const changeUntilDate = (e, date) => {
        setUntilDate(date);
        setFromMaxDate(date);
        
        changeDateRange(fromDate, date);
        getStatisticsEmails(
            moment(fromDate).utcOffset(0, true).valueOf(),
            moment(date).utcOffset(0, true).valueOf(),
        );
    };

    return (
        <div className='row'>
            <div className='col-xs-4'>
                <DatePicker
                    floatingLabelText='From'
                    autoOk
                    minDate={fromMinDate}
                    maxDate={fromMaxDate}
                    onChange={changeFromDate}
                    value={fromDate}
                    formatDate={date => moment(date).format('DD-MM-YYYY')}
                />
            </div>
            <div className='col-xs-4'>
                <DatePicker
                    floatingLabelText='Until'
                    autoOk
                    minDate={untilMinDate}
                    maxDate={untilMaxDate}
                    onChange={changeUntilDate}
                    value={untilDate}
                    formatDate={date => moment(date).format('DD-MM-YYYY')}
                />
            </div>
            <div className='col-sx-2' style={{ width: '200px', marginTop: '40px' }}>
                <Checkbox 
                    label='Normalized'
                    labelStyle={{ fontSize: '12px' }}
                    onCheck={handleNormalize}
                    checked={checked}
                />
            </div>
            <div className='col-sx-2' style={{ width: '200px', marginTop: '40px' }}>
                <Checkbox 
                    label='Working hours(GMT+2)'
                    labelStyle={{ fontSize: '12px' }}
                    onCheck={handleWorkingHours}
                    checked={workingHours}
                />
            </div>
        </div>
    );
};

export default connect(
    (state, { from, until, changeDateRange }) => ({
        from, until, changeDateRange,
    }),
    dispatch => bindActionCreators(
        {
            getStatisticsEmails,
        },
        dispatch,
    ),
)(RangeDates);



// WEBPACK FOOTER //
// ./app/components/Statistics/Emails/RangeDates.jsx